import React, {useEffect, useState} from 'react';
import {useAdvancedSearchMutation} from "../../core/api/rogerthat-state-api";
import MultiSearch from "./MultiSearch";

export default function SearchBarRT() {
    return <MultiSearch useSearchHook={useAdvancedSearchMutation} />
}